import $ from 'jquery';
import Marionette from 'backbone.marionette';
import DialogService from 'base/dialog_service';

class NameService {
    static createWithReport(args, cb) {
       // Display spinner
       const dialog = DialogService.show(new Marionette.LayoutView({
           template: require('names/templates/processing.html')
       }));
 
       $.post('/names-filter/?format=json', function (data){
           const uuid = data.uuid;

           // Now post report
           $.ajax({
               url: `/names-filter/${uuid}/report/?format=json`,
               method: 'POST',
               data: JSON.stringify(args),
               contentType : 'application/json',
           }).done(function (rsp){
                if(rsp.status !== 'ok'){
                    throw new Error('Names filter API did not return OK');
                }
                
                let check = () => {
                    $.get(`/names-filter/${uuid}/?format=json`, (rsp) => {
                        if(rsp.stage === 'd'){
                            // Done!
                            dialog.close();
                            cb(uuid, rsp.count);
                        } else{
                            setTimeout(check, 1000);
                        }
                    });
                };
                setTimeout(check, 4000);
           });
       });
    }
}

export default NameService;



// WEBPACK FOOTER //
// ./names/service.js